import { db } from "@/firebase";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  addDoc,
} from "firebase/firestore";

const ideas = {
  state: {
    show: false,
    ideas: [],
    tags: [],
    keywords: [],
  },
  mutations: {
    addIdea(state, val) {
      if (val.keywords) {
        val.keywords.map((k) => {
          if (!state.keywords[val.category]) {
            state.keywords[val.category] = [];
          }
          if (!state.keywords[val.category].includes(k)) {
            state.keywords[val.category].push(k);
          }
        });
      }
      state.ideas.unshift(val);
    },

    setIdeas(state, val) {
      state.ideas = val;
    },
    setIdeaKeywords(state, val) {
      state.keywords = val;
    },
    setIdeasShow(state, val) {
      state.show = val;
    },
    addTag(state, val) {
      val.forEach((t) => {
        if (!state.tags.includes(t)) {
          state.tags.unshift(t);
        }
      });
      state.tags.sort((a, b) => (a < b ? -1 : b < a ? 1 : 0));
    },

    updateIdea(state, val) {
      let i = state.ideas.findIndex((t) => t.uid === val.uid);
      state.ideas[i].idea = val.idea;
      state.ideas[i].tags = val.tags;
    },
    removeIdea(state, val) {
      let i = state.ideas.findIndex((t) => t.title === val.title);
      state.ideas.splice(i, 1);
    },
  },
  actions: {
    async favoriteIdea({ commit, dispatch, rootState }, val) {
      const ref = doc(
        db,
        "workspaces",
        rootState.workspace.workspace.uid,
        "ideas",
        val.uid,
      );

      if (val.value) {
        await updateDoc(ref, {
          favorites: arrayUnion(rootState.users.userProfile.uid),
        });
      } else {
        await updateDoc(ref, {
          favorites: arrayRemove(rootState.users.userProfile.uid),
        });
      }

      commit("setNotification", {
        show: true,
        text: `Idea updated!`,
        type: "primary",
        icon: "",
      });

      dispatch("fetchIdeas");
    },
    async fetchIdeas({ commit, rootState }) {
      commit("setLoading", { type: "ideas", val: true });
      let ideas = [];
      let keywords = {};
      const querySnapshot = await getDocs(
        collection(
          db,
          "workspaces",
          rootState.workspace.workspace.uid,
          "ideas",
        ),
      );
      querySnapshot.docs.map((doc) => {
        ideas.push(doc.data());
        if (doc.data().keywords) {
          if (!keywords[doc.data().category]) {
            keywords[doc.data().category] = [];
          }
          doc.data().keywords.map((t) => {
            if (
              !keywords[doc.data().category] ||
              !keywords[doc.data().category].includes(t)
            ) {
              keywords[doc.data().category].push(t);
            }
          });
          keywords[doc.data().category].sort((a, b) =>
            a < b ? -1 : b < a ? 1 : 0,
          );
        }
      });

      ideas.sort((a, b) =>
        a.created_at < b.created_at ? 1 : b.created_at < a.created_at ? -1 : 0,
      );

      commit("setIdeaKeywords", keywords);
      commit("setIdeas", ideas);

      commit("setLoading", { type: "ideas", val: false });
    },

    async saveIdea({ commit, rootState }, val) {
      commit("setLoading", { type: "ideas", val: true });
      if (val.uid) {
        await updateDoc(
          doc(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "ideas",
            val.uid,
          ),
          {
            idea: val.idea,
            tags: val.tags,
            category: val.category,
            title: val.title,
          },
        );
        commit("updateIdea", val);
        commit("setNotification", {
          show: true,
          text: "Idea updated!",
          type: "primary",
          icon: "",
        });
      } else {
        let new_idea = {
          idea: val.idea,
          created_by_email: rootState.users.userProfile.email,
          created_by: rootState.users.userProfile.uid,
          created_at: Math.floor(Date.now() / 1000),
          favorites: [],
          tags: val.tags ? val.tags : [],
          title: val.title,
          keywords: [],
          category: val.category,
          link: val.link,
        };
        const docRef = await addDoc(
          collection(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "ideas",
          ),
          new_idea,
        );
        await updateDoc(
          doc(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "ideas",
            docRef.id,
          ),
          {
            uid: docRef.id,
          },
        );
        new_idea.uid = docRef.id;
        commit("addIdea", new_idea);
        commit("setNotification", {
          show: true,
          text: "Idea added!",
          type: "primary",
          icon: "",
        });
      }

      if (val.tags?.length > 0) {
        commit("addTag", val.tags);
      }
      commit("setLoading", { type: "ideas", val: false });
    },

    async deleteIdea({ commit, rootState }, val) {
      commit("setLoading", { type: "ideas", val: true });
      console.log("deleting idea");
      console.log("VAL:", val);
      let r = confirm("Are you sure you want to delete this idea?");
      if (!r) {
        commit("setLoading", { type: "ideas", val: false });
        return;
      }

      if (!val || !val.uid) {
        console.warn("❌ val or val.uid missing:", val);
        commit("setLoading", { type: "ideas", val: false });
        return;
      }

      let sourceUid = null;

      // Handles both source being a string or an object
      if (typeof val.source === "string") {
        sourceUid = val.source;
      } else if (typeof val.source === "object" && val.source?.uid) {
        sourceUid = val.source.uid;
      } else if (val.source === undefined) {
        sourceUid = null;
      } else {
        console.warn("❌ Unexpected structure for val.source:", val.source);
      }
      console.log(sourceUid + " " + val.uid);

      if (sourceUid) {
        await updateDoc(
          doc(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "sources",
            sourceUid,
            "items",
            val.uid,
          ),
          {
            suggested: false,
          },
        );
      } else {
        await deleteDoc(
          doc(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "ideas",
            val.uid,
          ),
        );
      }

      commit("setNotification", {
        show: true,
        text: `Idea deleted!`,
        type: "primary",
        icon: "",
      });

      commit("removeIdea", val);

      commit("setLoading", { type: "ideas", val: false });
    },
  },
  getters: {},
};

export default ideas;
